// extracted by mini-css-extract-plugin
export var copyableField = "_rz-4";
export var customerBadge = "_rz-0";
export var customerInfoTitle = "_rz-2";
export var details = "_rz-1";
export var dropdownContainer = "_rz-5";
export var dropdownImage = "_rz-6";
export var editAssigneeForm = "_rz-a";
export var editButton = "_rz-3";
export var email = "_rz-7";
export var hidden = "_rz-d";
export var input = "_rz-8";
export var saveButton = "_rz-b";
export var shopifyIcon = "_rz-c";
export var suggestionBadge = "_rz-e";
export var suggestionText = "_rz-f";
export var username = "_rz-9";